
<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />

    <div>
      <div class="bodyCenter">
        <div class="modalStyle">
          <div class="titulos">
            <div class="seccionTitle">
              <b-icon icon="person-lines-fill" class="mLeft"></b-icon>
              <div class="headerTxt mLeft">Pacientes y Perfiles</div>
            </div>

            <div class="alignIcon bold">
              CA_01
              <b-button to="/dashboard" variant="outline-primary">
                <b-icon icon="x"></b-icon>
              </b-button>
            </div>
          </div>

          <div class="noAlTope">
            <b-tabs content-class="mt-3">
              <b-tab title="Paciente por nombre" active v-if="$localStorageService.can('CA_01_busqueda_pac_nombre')">
                <PacienteNombre />
              </b-tab>
              <b-tab title="Paciente por id" v-if="$localStorageService.can('CA_01_busqueda_pac_id')">
                <PacienteId />
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "../components/Header.vue";
import PacienteNombre from "../components/paciente/Pacientes.vue";
import PacienteId from "../components/paciente/PacientePorId";

export default {
  name: "bandejapacientes",
  components: {
    Header,
    PacienteNombre,
    PacienteId,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
};
</script>
